import { HomeIcon, UserIcon } from "@heroicons/react/24/outline";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import type { RegistryInfo } from "@/types";

interface ExOwnerInfoProps {
  currentOwner: RegistryInfo["moradores"][number] | null;
  registryInfo: RegistryInfo | null;
  propertyNumber: string;
}

export const ExOwnerInfo = ({
  currentOwner,
  registryInfo,
  propertyNumber,
}: ExOwnerInfoProps) => {
  return (
    <Card className="border-gray-200 shadow-sm overflow-hidden">
      <CardHeader>
        <CardTitle className="font-medium text-base">
          Dados para pesquisa
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6 pt-0 flex flex-col gap-6">
        <div className="grid md:grid-cols-2 gap-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-center">
              <UserIcon className="w-5 h-5 text-gray-500 mr-2" />
              <h2 className="font-medium text-muted-foreground">
                Proprietário Anterior:
              </h2>
            </div>
            <div className="pl-7 flex flex-col gap-2">
              <p className="text-sm">
                {currentOwner?.nome ? currentOwner.nome : "Não informado"}
              </p>
              <p className="text-sm font-medium text-muted-foreground">
                CPF: {currentOwner?.cpf ? currentOwner.cpf : "Não informado"}
              </p>
              <p className="text-sm font-medium text-muted-foreground">
                Data de Nascimento:{" "}
                {currentOwner?.data_nascimento
                  ? currentOwner.data_nascimento
                  : "Não informado"}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex items-center">
              <HomeIcon className="w-5 h-5 text-gray-500 mr-2" />
              <h2 className="font-medium text-muted-foreground">
                Proprietário Atual:
              </h2>
            </div>
            <div className="pl-7 flex flex-col gap-2">
              <p className="text-sm">
                {registryInfo?.atual_morador.nome || "Não informado"}
              </p>
              <p className="text-sm font-medium text-muted-foreground">
                CNPJ: {registryInfo?.atual_morador.cnpj || "Não informado"}
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-sm">
            Endereço:{" "}
            <span className="text-muted-foreground">
              {registryInfo?.imovel.endereco || "Não informado"}
            </span>
          </p>
          <p className="text-sm">
            Inscrição Imobiliária:{" "}
            <span className="text-muted-foreground">
              {registryInfo?.imovel.inscricao_imobiliaria ||
                propertyNumber ||
                "Não informado"}
            </span>
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
